import styled from 'styled-components'
import { colors } from '../styles/colors'

const hasBackground = ({ backgroundColor }: any) => {
  if (backgroundColor) return backgroundColor
  else return null
}

export const BoxFix = styled.div`
  min-width: 35px;
  background-color: #ccc;
`

const InputContent = styled.div<any>`
  height: ${(props: any) => (!props.rows ? '35px' : 'auto')};
  border-bottom: ${(props: any) => props.error && '2px solid red'};
  position: relative;
  background-color: ${(props: any) => hasBackground(props)};
  border-radius: 1px;
`

const Textarea = styled.textarea<any>`
  text-align: ${(props) => props.alignRight && 'right'};
  font-weight: ${(props) => props.bold && 'bold'};
  color: ${(props) =>
    props.color === 'success'
      ? `${colors.success}`
      : props.color === 'error'
      ? `${colors.alert}`
      : props.color === 'warning'
      ? `${colors.warning}`
      : ''};
  padding: 10px;
  opacity: ${(props) => props.disabled && '1'};
`
const Input = styled.input<any>`
  font-family: Atkinson Hyperlegible Regular;
  /* font-size: ${(props) => (props.size === 'large' ? '16px' : '12px')}; */
  text-align: ${(props) => props.alignRight && 'right'};
  font-weight: ${(props) => props.bold && 'bold'};
  color: ${(props) =>
    props.color === 'success'
      ? `${colors.success}`
      : props.color === 'error'
      ? `${colors.alert}`
      : props.color === 'warning'
      ? `${colors.warning}`
      : props.color === 'white'
      ? 'white'
      : ''};
  opacity: ${(props) => props.disabled && '1'};
  width: ${(props) => (props.width ? props.width : '100%')};
  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    margin: 0;
    padding: 0;
  }
  &::placeholder {
    font-style: italic;
  }
`

const Error = styled.div`
  font-size: 10px;
  height: 14px;
`
export { InputContent, Input, Error, Textarea }
